import {
  IEditorAction,
} from './actions';

import {
  EDITOR_DISCONNECTED,
  EDITOR_CONNECTED,
  CHANGE_CODE,
  RESET_CODE,
} from './constants';

export interface IEditorState {
  editorConnected: boolean;
  value: string;
}

const initialState: IEditorState = {
  editorConnected: false,
  value: '',
};

export default function consoleReducer(state: IEditorState = initialState, action: IEditorAction): IEditorState {
  switch (action.type) {
    case EDITOR_DISCONNECTED:
      return {...state, editorConnected: false};

    case EDITOR_CONNECTED:
      return {...state, editorConnected: true};

    case CHANGE_CODE:
      return {...state, value: action.payload.value};

    case RESET_CODE:
      return {...state, value: null};

    default:
      return state;
  }
}
